export default __webpack_public_path__ + "static/media/facebook.2eb911c5.svg";